var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{attrs:{"formclass":"Doctor/form","endpoint":"doctors","aditionalColumns":_vm.headers}},[[_c('h1',[_vm._v("Cadastro de Médicos")]),_c('v-divider',{staticClass:"mb-4"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }